var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8l1.8 8.2 1.3-5.4 1.3 5.4L9.7 8l-1.4-.1-.9 4.5L6.6 8H5l-.8 4.4L3.3 8H3.5zM10.5 8H12v8.2h-1.5V8zM13.5 8l2.2 4-2.3 4.2h1.7l1.4-2.6 1.4 2.6h1.7L17.3 12 19.5 8H17.8l-1.3 2.5L15.2 8h-1.7z",
    fill: "#FFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3,
    cy: 6.5,
    r: 0.8,
    fill: "#FACD45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWix);
export default __webpack_public_path__ + "static/media/wix.39a435024e0839a87bd0c71af596be6e.svg";
export { ForwardRef as ReactComponent };